module.exports = __webpack_public_path__ + "img/bh_sheet_01.8db65da4.jpg";